/* globals window */
import configLocalJson from './local.json';
import configDevJson from './dev.json';
import configStageJson from './stage.json';
import configProdJson from './production.json';

function getConfig(key, env) {
	switch (env) {
		case 'local':
			return configLocalJson[key];
		case 'dev':
			return configDevJson[key];
		case 'stage':
			return configStageJson[key];
		case 'prod':
			return configProdJson[key];
		default:
			window.cchome && window.cchome.util && window.cchome.util.logger.warn('index.js', 'Didn\'t find window.ENV, setting window.ENV to prod', env);
			return configProdJson[key];
	}
}

export default getConfig;
